import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const StyledTabPanel = styled(Box)(({ theme, size = "medium" }) => ({}));
